// extracted by mini-css-extract-plugin
export default {"ScreenThreshold":"600","AsideThreshold":"950","content":"App_content__9D6q8","article":"App_article__JBL4I","asideright":"App_asideright__68x37","scrollable":"App_scrollable__wjB87"};